import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.element.addEventListener("submit", () => {
      // Defer to the next tick so the form submission completes before the
      // button is disabled — otherwise some browsers drop the click.
      setTimeout(() => {
        if (this.hasSubmitTarget) {
          this.submitTarget.disabled = true
          this.submitTarget.textContent = "Sending…"
        }
      }, 0)
    })
  }
}
